import { Suspense, useCallback, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import {
  NotificationsInner,
  NotificationsInnerQueryString,
} from "./NotificationsInner";
import { NotificationsInnerQuery } from "./__generated__/NotificationsInnerQuery.graphql";
import { NotificationsInner_slot$key } from "./__generated__/NotificationsInner_slot.graphql";

type Props = {
  slotRef: NotificationsInner_slot$key;
};

export const Notifications = ({ slotRef }: Props) => {
  const [queryRef, loadQuery] = useQueryLoader<NotificationsInnerQuery>(
    NotificationsInnerQueryString
  );

  const refetchNotificationPreferences = useCallback(() => {
    loadQuery({}, { fetchPolicy: "network-only" });
  }, [loadQuery]);

  useEffect(() => {
    refetchNotificationPreferences();
  }, [refetchNotificationPreferences]);

  return (
    <Suspense fallback={<Loader />}>
      {queryRef ? (
        <NotificationsInner
          slotRef={slotRef}
          notificationPreferencesRef={queryRef}
          refetchNotificationPreferences={refetchNotificationPreferences}
        />
      ) : null}
    </Suspense>
  );
};
